jQuery(document).ready(function(){
    window.requestAnimationFrame(function() {
        if ( objects.is_front_page ) {
            //    var controller = new ScrollMagic.Controller();
            //
            //    // loop through all elements except first and last
            //    jQuery('main section').not(':first-child').not(':last').each(function () {
            //
            //        // build a tween
            //        var mainSection = TweenMax.from(jQuery(this), 0.3, {
            //            autoAlpha: 0.5,
            //            y: '+=30',
            //            ease: Linear.easeNone
            //        });
            //
            //        // build a scene
            //        var scene = new ScrollMagic.Scene({
            //                triggerElement: this
            //            })
            //            .setTween(mainSection) // trigger a TweenMax.to tween
            //            .addTo(controller);
            //    });
            
            setTimeout(function() {
                TweenMax.fromTo(
                    jQuery('.logo, .hamburguer'), 0.8, 
                    { opacity: 0, ease: Linear.easeNone },
                    { opacity: 1, ease: Linear.easeNone}
                );

                TweenMax.fromTo(
                    jQuery('.grappe'), 0.8, 
                    { opacity: 0.8, top: '-210', ease: Linear.easeNone },
                    { opacity: 1, top: '-110', ease: Linear.easeNone}
                );
            
                TweenMax.fromTo(
                    jQuery('.banniere-slider'), 0.6, 
                    { opacity: 0.5, scale: '0.8', ease: Linear.easeNone },
                    { opacity: 1, scale: '1', ease: Linear.easeNone}
                );
            
                TweenMax.fromTo(
                    jQuery('.top-title'), 0.4, 
                    { opacity: 0, left: '-40', ease: Linear.easeNone },
                    { opacity: 1, left: '0', ease: Linear.easeNone}
                );
                
                TweenMax.fromTo(
                    jQuery('.mid-title, .bottom-title'), 0.4, 
                    { opacity: 0, top: '-40', ease: Linear.easeNone },
                    { opacity: 1, top: '0', ease: Linear.easeNone}
                ).delay(0.4);
            
                TweenMax.fromTo(
                    jQuery('.link-btn, .separator, .citation, .img-citation'), 0.2, 
                    { opacity: 0, ease: Linear.easeNone },
                    { opacity: 1, ease: Linear.easeNone}
                ).delay(0.8);
            }, 200);
        }
    });
});
